import {
  createColumn,
  createViewAction,
  formatCurrency,
  formatDateTime,
} from "../../../utils/helpers";
import { formatDate } from "../../../utils/helpers";
import { TransactionStatusTag } from "../../common/registerUtils";
import { FormActions } from "../../common/FormActions";
import { URL_UTILITY_TRANSACTIONS } from "../../../utils/urls";

const url = URL_UTILITY_TRANSACTIONS;

export const useUtilityTransactions = () => {
  const tableColumns = () => [
    createColumn("transaction_id", true, "Transaction ID"),
    createColumn("reference", true, "Reference"),
    createColumn("item_name", true, "Utility Type"),
    // createColumn(
    //   "amount",
    //   {
    //     type: "number",
    //     rangeNames: {
    //       startKey: "min_amount",
    //       endKey: "max_amount",
    //     },
    //   },
    //   "Amount",
    // ),
    createColumn("amount", false, "Amount"),
    createColumn("final_status", true, "status"),
    createColumn(
      "payment_date",
      {
        type: "date",
        rangeNames: {
          startKey: "date_from",
          endKey: "date_to",
        },
      },
      "Payment Date",
    ),
    createColumn("actions", false, "Actions"),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        final_status: <TransactionStatusTag status={item?.final_status} />,
        payment_date: formatDate(item?.payment_date),
        amount: formatCurrency(item?.amount),
        tran_type: item.item_name,
        actions: (
          <FormActions
            actions={[createViewAction(url, item?.transaction_id)]}
          />
        ),
      };
    }),
  ];
  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: {
              message: "No data available",
            },
          },
        ],
      };
    }

    return {
      sections: [
        {
          title: "Utility Payment Details",
          fields: {
            user_id: item?.user_id,
            provider_ref_id: item?.provider_ref_id,
            status: item?.status,
            amount: formatCurrency(item?.amount),
            MainPayment: formatCurrency(item?.MainPayment),
            PartnerCharge: formatCurrency(item?.PartnerCharge),
            YoyaCharge: formatCurrency(item?.YoyaCharge),
            VatCharge: formatCurrency(item?.VatCharge),
            payment_date: formatDateTime(item?.payment_date),
            item_name: item?.item_name,
            reference: item?.reference,
            phone_number: item?.customer_number,
          },
        },
      ],
    };
  };

  const initialFilters = {
    payment_type: "utility",
  };

  return { tableColumns, tableData, viewData, initialFilters };
};
